import React from 'react';

export default function StepClientSetup({ data, onChange, onNext }) {
  const update = (field, value) => onChange({ ...data, [field]: value });

  const valid = data.businessName?.trim() && data.url?.trim();

  return (
    <div>
      <div className="page-header">
        <div className="page-title">Client setup</div>
        <div className="page-sub">Enter the client's basic details to begin keyword research.</div>
      </div>

      <div className="card">
        <div className="card-title">Business information</div>
        <div className="card-sub">This will be used to personalise the keyword suggestions and label the final report.</div>

        <div className="form-row form-row-2 form-group">
          <div>
            <label>Business name *</label>
            <input
              type="text"
              placeholder="e.g. Kent Carpet Cleaners"
              value={data.businessName || ''}
              onChange={e => update('businessName', e.target.value)}
            />
          </div>
          <div>
            <label>Website URL *</label>
            <input
              type="url"
              placeholder="https://example.co.uk"
              value={data.url || ''}
              onChange={e => update('url', e.target.value)}
            />
          </div>
        </div>

        <div className="form-group">
          <label>Brief business description</label>
          <textarea
            rows={2}
            placeholder="Describe what the client does — this helps the AI generate more relevant keyword ideas"
            value={data.description || ''}
            onChange={e => update('description', e.target.value)}
          />
        </div>

        <div className="form-row form-row-2 form-group">
          <div>
            <label>Target country</label>
            <select value={data.country || 'GB'} onChange={e => update('country', e.target.value)}>
              <option value="GB">United Kingdom</option>
              <option value="US">United States</option>
              <option value="AU">Australia</option>
              <option value="CA">Canada</option>
              <option value="IE">Ireland</option>
            </select>
          </div>
          <div>
            <label>DataForSEO location code</label>
            <select value={data.locationCode || 2826} onChange={e => update('locationCode', parseInt(e.target.value))}>
              <option value={2826}>2826 — United Kingdom</option>
              <option value={2840}>2840 — United States</option>
              <option value={2036}>2036 — Australia</option>
              <option value={2124}>2124 — Canada</option>
              <option value={2372}>2372 — Ireland</option>
            </select>
          </div>
        </div>
      </div>

      <div className="actions">
        <button className="btn btn-primary" onClick={onNext} disabled={!valid}>
          Next: Services →
        </button>
      </div>
    </div>
  );
}
